import ZIcon from '../components/ZIcon'
import { ErrorIcon } from '../assets/icons'
import ZButton from '../components/ZButton'
import ZText from '../components/ZText'
import ZBottomContainer from '../components/ZBottomContainer'
import ZScreenContainer from '../components/ZScreenContainer'

const categorisationFeedbackText = `Based on the information provided it looks as though this investment isn't suitable for you.\n\nIf you believe you were incorrectly categorised please resubmit your investor category by clicking the button below.`

const CategorisationFeedback = ({
  onDecision,
  loading,
}: {
  onDecision: (resubmit: boolean) => void
  loading: boolean
}) => {
  return (
    <ZScreenContainer>
      <ZIcon
        Icon={ErrorIcon}
        title="Categorisation feedback icon"
        style={{ alignSelf: 'center' }}
      />

      <ZText whiteSpace="pre-wrap">{categorisationFeedbackText}</ZText>

      <ZBottomContainer>
        <ZButton loading={loading} onClick={() => onDecision(true)}>
          Resubmit Investor Category
        </ZButton>

        <ZButton disabled={loading} onClick={() => onDecision(false)}>
          I wish to leave this investment journey
        </ZButton>
      </ZBottomContainer>
    </ZScreenContainer>
  )
}

export default CategorisationFeedback
